/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Social/YouTube': {
    width: 28,
    height: 24,
    viewBox: '0 0 28 24',
    data: '<path pid="0" fill-rule="evenodd" d="M27.411 5.129C28 7.355 28 12 28 12s0 4.645-.573 6.871c-.334 1.242-1.272 2.21-2.482 2.532C22.75 22 14 22 14 22s-8.75 0-10.93-.597A3.569 3.569 0 0 1 .59 18.871C0 16.645 0 12 0 12s0-4.645.573-6.871c.334-1.242 1.272-2.21 2.482-2.532C5.25 2 14 2 14 2s8.75 0 10.93.597a3.569 3.569 0 0 1 2.481 2.532zM11.136 16.226L18.455 12l-7.319-4.226v8.452z"/>'
  }
})
